import * as BranchConnectorKeys from 'automation-ui-action-features/constants/BranchConnectorKeys';
import ConnectionTypes from 'automation-ui-action-features/constants/ConnectionTypes';
import * as ConnectorEdgeTypes from 'automation-ui-action-features/constants/ConnectorEdgeTypes';
export const ConnectorMixinDefaultValues = {
  [BranchConnectorKeys.NEXT_ACTION_ID]: null,
  [BranchConnectorKeys.EDGE_TYPE]: ConnectorEdgeTypes.STANDARD,
  [BranchConnectorKeys.CONNECTION_TYPE]: ConnectionTypes.SINGLE_CONNECTION
};
/**
 * `ConnectionMixin` defines common behavior among the connection objects
 * found on every action.  Some action's connections are Connectors themselves,
 * while other connections contain multiple Connectors.
 *
 * As a class mixin, `ConnectorMixin` is a function which returns a class that
 * extends the given class with the behavior common across all Connectors.
 *
 * See `SingleConnection` or `BranchConnector` for an example of how this mixin
 * is used.
 */
function ConnectorMixin(superClass) {
  class ConnectorMixinClass extends superClass {
    getNextActionId() {
      return this.get(BranchConnectorKeys.NEXT_ACTION_ID);
    }
    setNextActionId(nextActionId) {
      return this.set(BranchConnectorKeys.NEXT_ACTION_ID, nextActionId);
    }
    getEdgeType() {
      return this.get(BranchConnectorKeys.EDGE_TYPE);
    }
    isGoToEdge() {
      return this.getEdgeType() === ConnectorEdgeTypes.GOTO;
    }
  }
  return ConnectorMixinClass;
}
export default ConnectorMixin;